/**
 * * Элемент списка приоритетов для обновления в очереди задач
 */
export default class UpdateQueueTaskPriorityRequestItem  {
	/**
	 * * Номер приоритета
	 */
	PriorityId?: number;
	/**
	 * * Название
	 */
	Name!: string;
	/**
	 * * Описание
	 */
	Description!: string;
	/**
	 * * Цвет
	 */
	Color!: string;
	/**
	 * * Используется по умолчанию
	 */
	IsDefault: boolean = false;
	/**
	 * * Порядковфй номер
	 */
	Number!: number;
	constructor(obj?: Partial<UpdateQueueTaskPriorityRequestItem>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
